module.exports = __webpack_public_path__ + "static/media/md-glasses.af207216.svg";